import { type MaskitoOptions, maskitoUpdateElement } from '@maskito/core';
import { maskitoEventHandler, maskitoPrefixPostprocessorGenerator } from '@maskito/kit';
import { maskWithPlaceholder } from 'utils/maskito';

export const OFFER_CODE_MAIL_OFFER_TOOLTIP =
  'Your 12-digit offer code is located on the first page of your Pre-Approved mail offer';

export const OFFER_CODE_EMAIL_OR_MAIL_OFFER =
  'Check your email or mail offer for the 12-digit code';

export const MIN_OFFER_CODE_LENGTH = 12;

export const OFFER_CODE_MASK = 'X';

export const STANDARD_OFFER_CODE_PLACEHOLDER = 'XXXX-XXXX-XXXX';

export const REINSTATEMENT_PREFIX = 'R';
export const REINSTATEMENT_OFFER_CODE_PLACEHOLDER = `${REINSTATEMENT_PREFIX}XXX-XXXX-XXXX`;

export const STANDARD_OFFER_CODE_MASK_OPTIONS: MaskitoOptions = maskWithPlaceholder(
  [/\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],
  STANDARD_OFFER_CODE_PLACEHOLDER,
);

const reinstatementMaskWithPlaceholder = maskWithPlaceholder(
  [
    REINSTATEMENT_PREFIX,
    /\d/,
    /\d/,
    /\d/,
    '-',
    /\d/,
    /\d/,
    /\d/,
    /\d/,
    '-',
    /\d/,
    /\d/,
    /\d/,
    /\d/,
  ],
  REINSTATEMENT_OFFER_CODE_PLACEHOLDER,
  REINSTATEMENT_PREFIX,
);

export const REINSTATEMENT_OFFER_CODE_MASK_OPTIONS: MaskitoOptions = {
  mask: reinstatementMaskWithPlaceholder.mask,
  preprocessors: reinstatementMaskWithPlaceholder.preprocessors,
  postprocessors: [
    maskitoPrefixPostprocessorGenerator(REINSTATEMENT_PREFIX),
    ...reinstatementMaskWithPlaceholder.postprocessors,
  ],
  plugins: [
    ...reinstatementMaskWithPlaceholder.plugins,
    //Add prefix on focus
    maskitoEventHandler('focus', (element) => {
      const initialValue = element.value || REINSTATEMENT_PREFIX;

      maskitoUpdateElement(
        element,
        initialValue + REINSTATEMENT_OFFER_CODE_PLACEHOLDER.slice(initialValue.length),
      );
    }),
  ],
};
